// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/logo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("images/loader_white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("images/loader_blue.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("images/button_up.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../public/logo_white.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    font-family: 'Poppins' !important;
}

:root {
    --dl-color-gray-500: #595959;
    --dl-color-gray-700: #999999;
    --dl-color-gray-900: #d9d9d9;
    --dl-size-size-large: 144px;
    --dl-size-size-small: 48px;
    --dl-color-danger-300: #a22020;
    --dl-color-danger-500: #bf2626;
    --dl-color-danger-700: #e14747;
    --dl-color-gray-black: #000000;
    --dl-color-gray-white: #ffffff;
    --dl-size-size-medium: 96px;
    --dl-size-size-xlarge: 192px;
    --dl-size-size-xsmall: 16px;
    --dl-space-space-unit: 8px;
    --dl-color-primary-100: #003eb3;
    --dl-color-primary-300: #0074f0;
    --dl-color-primary-500: #14a9ff;
    --dl-color-primary-700: #85dcff;
    --dl-color-success-300: #199033;
    --dl-color-success-500: #32a94c;
    --dl-color-success-700: #4cc366;
    --dl-size-size-xxlarge: 288px;
    --dl-size-size-maxwidth: 1400px;
    --dl-radius-radius-round: 50%;
    --dl-color-custom-accent1: #ffe4df;
    --dl-space-space-halfunit: 8px;
    --dl-space-space-sixunits: 96px;
    --dl-space-space-twounits: 32px;
    --dl-color-custom-primary1: #d53636;
    --dl-color-custom-primary2: #a92323;
    --dl-radius-radius-radius2: 2px;
    --dl-radius-radius-radius4: 4px;
    --dl-radius-radius-radius8: 8px;
    --dl-space-space-fiveunits: 80px;
    --dl-space-space-fourunits: 64px;
    --dl-space-space-threeunits: 48px;
    --dl-color-custom-secondary1: #c9edf3;
    --dl-color-custom-neutral-dark: #27284e;
    --dl-color-custom-neutral-light: #ffffff;
    --dl-space-space-oneandhalfunits: 24px;
    --dl-grid-gap-space: 8px;

    --dl-color-custom-font: black;
    --dl-color-custom-primary: #1c7ba8;
    --dl-color-custom-primary-darker: #14a9ff;
    --dl-color-custom-secondary: #ffffff;
    --dl-color-custom-secondary-darker: #d9d9d9;
}
.button {
    color: var(--dl-color-gray-black);
    display: inline-block;
    padding: 0.5rem 1rem;
    border-color: var(--dl-color-gray-black);
    border-width: 1px;
    border-radius: 4px;
    background-color: var(--dl-color-gray-white);
}
.input {
    color: var(--dl-color-custom-font) !important;
    cursor: auto;
    padding: 0.5rem 1rem;
    border-color: var(--dl-color-custom-primary);
    border-width: 1px;
    border-radius: 4px;
    background-color: var(--dl-color-custom-secondary);
}
.textarea {
    color: var(--dl-color-custom-font);
    cursor: auto;
    padding: 0.5rem;
    border-color: var(--dl-color-custom-primary);
    border-width: 1px;
    border-radius: 4px;
    background-color: var(--dl-color-custom-secondary);
}
.list {
    width: 100%;
    margin: 1em 0px 1em 0px;
    display: block;
    padding: 0px 0px 0px 1.5rem;
    list-style-type: none;
    list-style-position: outside;
}
.list-item {
    display: list-item;
}
.teleport-show {
    display: flex !important;
    transform: none !important;
}
.buttonFilled {
    color: var(--dl-color-custom-secondary) !important;
    transition: 0.3s;
    font-weight: bold !important;
    padding-top: var(--dl-space-space-halfunit) !important;
    padding-left: var(--dl-space-space-oneandhalfunits) !important;
    border-radius: 8px !important;
    padding-right: var(--dl-space-space-oneandhalfunits) !important;
    padding-bottom: var(--dl-space-space-halfunit) !important;
    background-color: var(--dl-color-custom-primary) !important;
    margin-top: 10px !important;
}
.buttonFilled:hover {
    background-color: var(--dl-color-custom-primary-darker) !important;
}
.buttonFilledSecondary {
    color: var(--dl-color-custom-secondary);
    transition: 0.3s;
    font-weight: bold;
    padding-top: var(--dl-space-space-halfunit);
    padding-left: var(--dl-space-space-oneandhalfunits);
    padding-right: var(--dl-space-space-oneandhalfunits);
    padding-bottom: var(--dl-space-space-halfunit);
    background-color: var(--dl-color-custom-primary);
}
.buttonFilledSecondary:hover {
    background-color: var(--dl-color-custom-primary-darker);
}
.buttonOutline {
    color: var(--dl-color-custom-primary);
    border: 1px solid;
    font-weight: bold;
    padding-top: var(--dl-space-space-halfunit);
    border-color: var(--dl-color-custom-primary);
    padding-left: var(--dl-space-space-oneandhalfunits);
    border-radius: 8px;
    padding-right: var(--dl-space-space-oneandhalfunits);
    padding-bottom: var(--dl-space-space-halfunit);
}
.buttonOutline:hover {
    background-color: var(--dl-color-custom-primary-darker);
}
.buttonFlat {
    color: var(--dl-color-custom-primary);
    font-weight: bold;
    padding-top: var(--dl-space-space-halfunit);
    padding-left: var(--dl-space-space-oneandhalfunits);
    padding-right: var(--dl-space-space-oneandhalfunits);
    padding-bottom: var(--dl-space-space-halfunit);
}
.buttonFlat:hover {
    color: var(--dl-color-custom-primary-darker);
}
.featuresContainer {
    flex: 0 0 auto;
    color: var(--dl-color-custom-font);
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    background-color: var(--dl-color-custom-secondary);
}

.featuresCard {
    width: 100%;
    display: flex;
    padding: var(--dl-space-space-oneandhalfunits);
    align-items: center;
    flex-direction: row;
    justify-content: flex-start;
    color: #000;
    background-color: #e5e7eb;
    border-radius: 5px;
    position: relative;
}

.featuresIcon {
    fill: #000;
    width: 3rem;
    height: 3rem;
    flex-shrink: 0;
    margin-right: var(--dl-space-space-oneandhalfunits);
    margin-top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.freePricingCard {
    gap: var(--dl-space-space-twounits);
    color: var(--dl-color-custom-secondary);
    width: 100%;
    display: flex;
    padding: var(--dl-space-space-twounits);
    max-width: 450px;
    min-height: 450px;
    align-items: flex-start;
    flex-direction: column;
    background-color: var(--dl-color-custom-primary);
}
.basicPricingCard {
    gap: var(--dl-space-space-twounits);
    color: var(--dl-color-custom-secondary);
    width: 100%;
    display: flex;
    padding: var(--dl-space-space-twounits);
    max-width: 450px;
    min-height: 450px;
    align-items: flex-start;
    flex-direction: column;
    background-color: var(--dl-color-custom-primary);
}
.proPricingCard {
    gap: var(--dl-space-space-twounits);
    color: var(--dl-color-custom-secondary);
    width: 100%;
    display: flex;
    padding: var(--dl-space-space-twounits);
    max-width: 450px;
    min-height: 450px;
    align-items: flex-start;
    flex-direction: column;
    background-color: var(--dl-color-custom-primary);
}
.faqContainer {
    flex: 0 0 auto;
    color: var(--dl-color-custom-secondary);
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    background-color: var(--dl-color-custom-primary);
}
.navbarContainer {
    color: var(--dl-color-custom-font);
    width: 100%;
    display: flex;
    align-items: center;
    padding-top: var(--dl-space-space-oneandhalfunits);
    padding-left: var(--dl-space-space-threeunits);
    padding-right: var(--dl-space-space-threeunits);
    padding-bottom: var(--dl-space-space-oneandhalfunits);
    justify-content: space-between;
    background-color: var(--dl-color-custom-secondary);
    height: 80px;
    border-bottom: #e5e7eb solid 1px;
}

@media only screen and (max-width: 820px) {
    .navbarContainer {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .home-desktop-menu {
        display: none !important;
    }
}

.mobileMenu {
    color: var(--dl-color-custom-font);
    background-color: var(--dl-color-custom-secondary);
}
.heroContainer {
    color: var(--dl-color-custom-font);
    width: 100%;
    display: flex;
    min-height: auto;
    align-items: center;
    padding-top: var(--dl-space-space-sixunits);
    padding-left: var(--dl-space-space-threeunits);
    padding-right: var(--dl-space-space-threeunits);
    flex-direction: column;
    padding-bottom: var(--dl-space-space-sixunits);
    justify-content: center;
    background-color: var(--dl-color-custom-secondary);
}
.pricingContainer {
    gap: var(--dl-space-space-twounits);
    color: var(--dl-color-custom-font);
    width: 100%;
    display: flex;
    align-items: center;
    padding-top: var(--dl-space-space-fourunits);
    padding-left: var(--dl-space-space-threeunits);
    padding-right: var(--dl-space-space-threeunits);
    flex-direction: column;
    padding-bottom: var(--dl-space-space-fourunits);
    justify-content: center;
    background-color: var(--dl-color-custom-secondary);
}
.bannerContainer {
    color: var(--dl-color-custom-font);
    width: 100%;
    display: flex;
    align-items: center;
    padding-top: var(--dl-space-space-sixunits);
    padding-left: var(--dl-space-space-fiveunits);
    padding-right: var(--dl-space-space-fiveunits);
    flex-direction: column;
    padding-bottom: var(--dl-space-space-sixunits);
    justify-content: space-between;
    background-color: var(--dl-color-custom-secondary);
}
.footerContainer {
    color: var(--dl-color-custom-font);
    width: 100%;
    display: flex;
    align-items: center;
    padding-top: var(--dl-space-space-twounits);
    padding-left: var(--dl-space-space-threeunits);
    padding-right: var(--dl-space-space-threeunits);
    flex-direction: column;
    padding-bottom: var(--dl-space-space-twounits);
    justify-content: space-between;
    background-color: var(--dl-color-custom-secondary);
}
.socialIcons {
    fill: var(--dl-color-custom-font);
}
.Heading {
    font-size: 32px;
    font-family: 'Poppins';
    font-weight: 700;
    line-height: 1.15;
    text-transform: none;
    text-decoration: none;
}
.heading3 {
    font-size: 20px;
    text-align: center;
    font-family: 'Poppins';
    font-weight: 600;
    line-height: 150%;
}
.Content {
    font-size: 16px;
    font-family: 'Poppins';
    font-weight: 400;
    line-height: 1.15;
    text-transform: none;
    text-decoration: none;
}
.overline {
    font-size: 12px;
    font-family: 'Poppins';
    font-weight: 700;
    line-height: 150%;
    text-transform: uppercase;
}
.heading2 {
    font-size: 35px;
    font-family: 'Poppins';
    font-weight: 600;
    line-height: 150%;
}
.bodyLarge {
    font-size: 18px;
    font-weight: 400;
    line-height: 150%;
}
.heading1 {
    font-size: 48px;
    text-align: center;
    font-family: 'Poppins';
    font-weight: 700;
    line-height: 150%;
}
.bodySmall {
    font-size: 16px;
    font-weight: 400;
    line-height: 150%;
}
.absence-container {
    margin-top: 150px;
    max-width: 50%;
}
.logo {
    font-size: 2em;
    font-weight: 700;
    line-height: 150%;
    text-transform: uppercase;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* Replace with your logo path */
    background-size: cover;
    width: 250px;
    height: 100px;
    margin-top: -25px;
}

@media only screen and (min-width: 821px) {
    .home-header .logo {
        margin-top: 0 !important;
        margin-left: 0 !important;
        margin-right: auto !important;
        margin-bottom: 0 !important;
        width: auto;
        height: auto;
        min-height: 0;
        background: none !important;
        display: inline-flex;
        align-items: baseline;
        gap: 0;
        line-height: 1;
        text-transform: none;
        font-family: 'Poppins' !important;
        justify-content: flex-start;
        text-align: left;
        align-self: center;
    }

    .home-header .logo::before {
        content: 'Agema';
        color: #1f1f1f;
        font-size: 36px;
        font-weight: 500;
        letter-spacing: 0;
    }

    .home-header .logo::after {
        content: 'HOME';
        color: #2280b3;
        font-size: 36px;
        font-weight: 700;
        letter-spacing: 0;
    }
}

body {
    min-height: 100%;
    background-color: var(--dl-color-custom-secondary);
}

html,
body,
#root,
.home-container {
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
}


form {
    background: none;
    color: var(--dl-color-custom-font);
}

.MuiPaper-root {
    background: transparent !important;
    border: 0 !important;
}

form fieldset {
    border-color: var(--dl-color-custom-primary) !important;
    color: var(--dl-color-custom-font) !important;
}

form button span {
    color: var(--dl-color-custom-secondary) !important;
}

form label {
    color: var(--dl-color-custom-font) !important;
}

.MuiInputBase-input {
    color: var(--dl-color-custom-font) !important;
    background: none !important;
    opacity: 1 !important;
    -webkit-text-fill-color: rgba(0, 0, 0, 1) !important;
}

.MuiInputBase-formControl {
    background: none !important;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
    -webkit-transition: background-color 5000s ease-in-out 0s;
    transition: background-color 5000s ease-in-out 0s;
    color: var(--dl-color-custom-font);
}

.padding-body {
    padding: 50px;
}

.padding-body-2 {
    padding: 20px;
}

.padding-body-small {
    padding: 20px;
}

.document-list th {
    color: var(--dl-color-custom-font);
    font-weight: bold;
}

.document-list td {
    color: var(--dl-color-custom-font);
}

.not-mobile {
    width: 100%;
}

.only-mobile {
    display: none !important;
}

.MuiOutlinedInput-notchedOutline {
    color: var(--dl-color-custom-primary);
}

.absenceList-button {
    margin-top: -20px !important;
}

.MuiList-root {
    background-color: #fff;
}

.MuiMenuItem-root {
    color: #000 !important;
}

fieldset legend span {
    color: var(--dl-color-custom-primary) !important;
}

.MuiSvgIcon-root {
    color: #fff !important;
}

input[type='date']::-webkit-calendar-picker-indicator {
    cursor: pointer;
    border-radius: 4px;
    margin-right: 2px;
    opacity: 1;
    filter: invert(0.8);
}

input[type='date']::-webkit-calendar-picker-indicator:hover {
    opacity: 1;
}

.MuiButton-root {
    padding-top: 10px !important;
}

.feature-card-text {
    text-align: left;
}

.home-features-heading {
    text-align: center;
}

.cancelButton {
    width: 100%;
    display: block;
    text-align: center;
    cursor: pointer;
}

.cancelButton:hover {
    color: var(--dl-color-custom-primary1) !important;
}

.validation-error {
    color: var(--dl-color-custom-primary2);
}

.validation-error-green {
    color: var(--dl-color-success-300);
}

.width100 {
    width: 100%;
}

.loader {
    animation: loading-spinner 0.7s linear infinite;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    height: 10px;
    width: 10px !important;
    margin: 0 auto;
    display: flex;
}

.loader svg path {
    fill: #000;
}

.loader-black {
    animation: loading-spinner 0.7s linear infinite;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    height: 30px;
    width: 30px !important;
    margin: 0 auto;
    display: flex;
}

.other .loader {
    margin-top: 50px;
}

input:-webkit-autofill {
    -webkit-text-fill-color: var(--dl-color-custom-primary) !important;
}

.validation-message {
    line-height: 20px;
    margin: 12px 0;
    color: var(--dl-color-custom-primary1);
    margin-top: 0px;
    margin-bottom: 20px;
}

.red-dot {
    width: 10px;
    height: 10px;
    background-color: var(--dl-color-custom-primary1);
    border-radius: 50%;
    position: absolute;
    right: 40px;
    margin-top: 10px;
}

.green-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    position: absolute;
    right: 40px;
    color: #000;
}

.green-dot-web {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  right: 40px;
  color:#000;
}

.green-dot-web {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  right: 40px;
  color:#000;
}

.holiday-info {
    font-size: 13px;
    margin-top: 5px;
    display: block;
}

.mt-5 {
    margin-top: 5px;
}

.white-progress {
    height: 10px;
    border-radius: 5px;
    background-color: rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

.white-progress .MuiLinearProgress-bar {
    background-color: currentColor !important;
}

.chat-gpt {
    margin-top: 10px;
}

.mt-10 {
    margin-top: 15px;
}

.forgot-password {
    color: var(--dl-color-custom-primary);
}

.chat-gpt h5 {
    background: var(--dl-color-custom-secondary);
    border-radius: 5px;
    padding: 5px;
    display: block;
    margin-bottom: 10px;
}

.chat-gpt p {
    margin: 5px;
    margin-bottom: 10px;
}

.MuiDialog-paper {
    background-color: var(--dl-color-custom-secondary) !important;
}

.MuiDialogActions-root .cancelButton {
    margin-top: 7px;
    color: #000;
    cursor: pointer;
}

.MuiDialogActions-root button {
    background-color: var(--dl-color-custom-primary) !important;
}

.scroll-top-button {
    color: var(--dl-color-custom-secondary) !important;
    position: fixed !important;
    bottom: 20px;
    right: 20px;
    height: 52px;
    width: 52px;
}

.scroll-top-button svg {
    height: 50px;
    width: 50px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    margin: 0 auto;
    display: flex;
}

.scroll-top-button svg path{
  display: none;
} 

.button-circle {
    color: var(--dl-color-custom-secondary) !important;
    height: 52px;
    width: 52px;
    float: right;
}

.button-circle svg {
    height: 52px;
    width: 52px;
    fill: var(--dl-color-custom-primary) !important;
}

.pointer {
    cursor: pointer;
    font-weight: 300;
}

.absence-item-wrapper {
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
}

.delete-button-area {
    position: absolute;
    right: 0;
    height: 97%;
    width: 70px;
    background-color: red;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
}

.delete-btn {
    background: none;
    border: none;
    color: white;
    font-size: 24px;
    cursor: pointer;
}

.absence-item-content {
    flex: 1 1;
    transition: transform 0.3s ease;
    will-change: transform;
}

.absence-item-content.slid {
    transform: translateX(-70px);
}

.MuiSvgIcon-root{
  color:#000 !important;
}

.absenceRejectLink{
  color:#fe0000
}

@keyframes loading-spinner {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

@media only screen and (max-width: 820px) {
    .logo {
        margin: 0 auto;
        background-position-x: 20px;
    }

    .home-header .logo {
        margin: 0 auto !important;
        width: auto;
        height: auto;
        min-height: 0;
        background: none !important;
        display: inline-flex;
        align-items: baseline;
        gap: 0;
        line-height: 1;
        text-transform: none;
        font-family: 'Poppins' !important;
        justify-content: center;
        text-align: left;
        align-self: center;
    }

    .home-header .logo::before {
        content: 'Agema';
        color: #1f1f1f;
        font-size: 36px;
        font-weight: 500;
        letter-spacing: 0;
    }

    .home-header .logo::after {
        content: 'HOME';
        color: #2280b3;
        font-size: 36px;
        font-weight: 700;
        letter-spacing: 0;
    }

    .buttonFilled {
        margin-top: 20px !important;
        margin-bottom: 20px !important;
    }

    .center .buttonFilled {
        margin: 0 auto;
        margin-top: -20px;
    }

    .not-mobile {
        display: none !important;
    }

    .only-mobile {
        display: block !important;
    }

    .only-mobile .heading3 {
        text-align: left;
        font-family: 'Poppins';
        font-size: 18px;
    }

    .home-burger-menu {
        display: none !important;
    }

    .only-mobile .bodySmall {
        font-size: 14px;
        font-family: 'Poppins';
    }

    .only-mobile .bodySmall-2 {
        font-size: 14px;
        font-family: 'Poppins';
        max-width: 80%;
        word-break: break-all;
        white-space: normal;
    }

    .MuiSelect-icon,
    .MuiSelect-iconOutlined {
        color: var(--dl-color-custom-font) !important;
    }

    .absence-container {
        margin-top: 80px;
        max-width: 100%;
    }

    .home-text51 {
        text-align: center;
    }

    .home-btn-group {
        width: 100%;
        text-align: center;
    }

    .clr {
        clear: both;
    }

    body {
        line-height: 18px !important;
    }

    .absence-card {
        padding-top: 15px;
        padding-bottom: 20px;
    }

    .absence-card .bodySmall {
        line-height: 10px;
    }

    .faqContainer .bodySmall {
        text-align: center !important;
    }

    .margin-bottom-0 {
        margin-bottom: 0 !important;
    }

    .navbarContainer {
        height: 100px;
    }

    .logo {
        margin-top: -20px;
    }

    .absenceLink {
        color: #666;
    }
}

@media (prefers-color-scheme: dark) {
    .home-navbar-interactive {
        background-color: #121212;
    }

    .home-header .logo::before {
        color: #ffffff;
    }

    .logo {
        background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}); /* Replace with your logo path */
        background-size: cover;
        width: 250px; /* Set a width for the element */
        height: 100px; /* Set a height for the element */
    }

    :root {
        --dl-color-custom-neutral-light: #121212 !important;
        --dl-color-gray-white: #121212 !important;
        --dl-color-custom-neutral-light: #121212 !important;
        --dl-color-custom-neutral-light: #121212 !important;
        --dl-color-custom-secondary-darker: #121212 !important;
    }

    html,
    body,
    #root,
    .home-container {
        background-color: #121212 !important;
        color: #fff !important;
    }

    form {
        background-color: #121212 !important;
        color: #fff !important;
    }

    .MuiFormControl-root,
    .MuiInputBase-root,
    .MuiOutlinedInput-root,
    .MuiInputBase-formControl {
        background-color: #1a2733 !important;
    }

    .MuiOutlinedInput-notchedOutline {
        border-color: #2a9cda !important;
    }

    .MuiInputBase-input,
    .MuiSelect-select,
    textarea.MuiInputBase-input {
        color: #fff !important;
        -webkit-text-fill-color: rgba(255, 255, 255, 1) !important;
    }

    form label,
    .MuiFormLabel-root,
    .MuiInputLabel-root {
        color: #fff !important;
    }

    .heroContainer {
        background-color: #121212 !important;
    }

    .featuresContainer {
        background-color: #121212 !important;
    }

    .bannerContainer {
        background-color: #121212 !important;
        color: #fff;
    }

    .footerContainer {
        background-color: #121212 !important;
    }

    .heroContainer {
        color: #fff;
    }

    .home-container2 {
        color: #fff;
    }

    .document-list th {
        color: #fff;
    }

    .document-list td {
        color: #fff;
    }

}

/* AbsenceCard */

.absence-card-box {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 10px 16px;
    border-radius: 8px;
    background-color: #e5e7eb;
    color: #000;
    box-sizing: border-box;
    cursor: pointer;
}

.absence-card-left {
    flex: 0 0 48px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.absence-card-center {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.absence-card-right {
    flex: 0 0 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.absence-type-icon {
    width: 3rem;
    height: 3rem;
    display: block;
}

.status-icon {
    font-size: 30px !important;
    color: #000 !important;
    opacity: 0.7;
    transform: scale(0.9);
}

.absence-card-center .feature-card-text {
    margin: 0 0 4px 0;
    text-align: left;
}

.absence-card-center .bodySmall {
    display: block;
    line-height: 1.4;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;AACrC;;AAEA;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,8BAA8B;IAC9B,8BAA8B;IAC9B,8BAA8B;IAC9B,8BAA8B;IAC9B,8BAA8B;IAC9B,2BAA2B;IAC3B,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,+BAA+B;IAC/B,+BAA+B;IAC/B,+BAA+B;IAC/B,+BAA+B;IAC/B,+BAA+B;IAC/B,+BAA+B;IAC/B,+BAA+B;IAC/B,6BAA6B;IAC7B,+BAA+B;IAC/B,6BAA6B;IAC7B,kCAAkC;IAClC,8BAA8B;IAC9B,+BAA+B;IAC/B,+BAA+B;IAC/B,mCAAmC;IACnC,mCAAmC;IACnC,+BAA+B;IAC/B,+BAA+B;IAC/B,+BAA+B;IAC/B,gCAAgC;IAChC,gCAAgC;IAChC,iCAAiC;IACjC,qCAAqC;IACrC,uCAAuC;IACvC,wCAAwC;IACxC,sCAAsC;IACtC,wBAAwB;;IAExB,6BAA6B;IAC7B,kCAAkC;IAClC,yCAAyC;IACzC,oCAAoC;IACpC,2CAA2C;AAC/C;AACA;IACI,iCAAiC;IACjC,qBAAqB;IACrB,oBAAoB;IACpB,wCAAwC;IACxC,iBAAiB;IACjB,kBAAkB;IAClB,4CAA4C;AAChD;AACA;IACI,6CAA6C;IAC7C,YAAY;IACZ,oBAAoB;IACpB,4CAA4C;IAC5C,iBAAiB;IACjB,kBAAkB;IAClB,kDAAkD;AACtD;AACA;IACI,kCAAkC;IAClC,YAAY;IACZ,eAAe;IACf,4CAA4C;IAC5C,iBAAiB;IACjB,kBAAkB;IAClB,kDAAkD;AACtD;AACA;IACI,WAAW;IACX,uBAAuB;IACvB,cAAc;IACd,2BAA2B;IAC3B,qBAAqB;IACrB,4BAA4B;AAChC;AACA;IACI,kBAAkB;AACtB;AACA;IACI,wBAAwB;IACxB,0BAA0B;AAC9B;AACA;IACI,kDAAkD;IAClD,gBAAgB;IAChB,4BAA4B;IAC5B,sDAAsD;IACtD,8DAA8D;IAC9D,6BAA6B;IAC7B,+DAA+D;IAC/D,yDAAyD;IACzD,2DAA2D;IAC3D,2BAA2B;AAC/B;AACA;IACI,kEAAkE;AACtE;AACA;IACI,uCAAuC;IACvC,gBAAgB;IAChB,iBAAiB;IACjB,2CAA2C;IAC3C,mDAAmD;IACnD,oDAAoD;IACpD,8CAA8C;IAC9C,gDAAgD;AACpD;AACA;IACI,uDAAuD;AAC3D;AACA;IACI,qCAAqC;IACrC,iBAAiB;IACjB,iBAAiB;IACjB,2CAA2C;IAC3C,4CAA4C;IAC5C,mDAAmD;IACnD,kBAAkB;IAClB,oDAAoD;IACpD,8CAA8C;AAClD;AACA;IACI,uDAAuD;AAC3D;AACA;IACI,qCAAqC;IACrC,iBAAiB;IACjB,2CAA2C;IAC3C,mDAAmD;IACnD,oDAAoD;IACpD,8CAA8C;AAClD;AACA;IACI,4CAA4C;AAChD;AACA;IACI,cAAc;IACd,kCAAkC;IAClC,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,kDAAkD;AACtD;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8CAA8C;IAC9C,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,cAAc;IACd,mDAAmD;IACnD,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mCAAmC;IACnC,uCAAuC;IACvC,WAAW;IACX,aAAa;IACb,uCAAuC;IACvC,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,sBAAsB;IACtB,gDAAgD;AACpD;AACA;IACI,mCAAmC;IACnC,uCAAuC;IACvC,WAAW;IACX,aAAa;IACb,uCAAuC;IACvC,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,sBAAsB;IACtB,gDAAgD;AACpD;AACA;IACI,mCAAmC;IACnC,uCAAuC;IACvC,WAAW;IACX,aAAa;IACb,uCAAuC;IACvC,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,sBAAsB;IACtB,gDAAgD;AACpD;AACA;IACI,cAAc;IACd,uCAAuC;IACvC,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,gDAAgD;AACpD;AACA;IACI,kCAAkC;IAClC,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,kDAAkD;IAClD,8CAA8C;IAC9C,+CAA+C;IAC/C,qDAAqD;IACrD,8BAA8B;IAC9B,kDAAkD;IAClD,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI;QACI,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;IACvB;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,kCAAkC;IAClC,kDAAkD;AACtD;AACA;IACI,kCAAkC;IAClC,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,2CAA2C;IAC3C,8CAA8C;IAC9C,+CAA+C;IAC/C,sBAAsB;IACtB,8CAA8C;IAC9C,uBAAuB;IACvB,kDAAkD;AACtD;AACA;IACI,mCAAmC;IACnC,kCAAkC;IAClC,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,4CAA4C;IAC5C,8CAA8C;IAC9C,+CAA+C;IAC/C,sBAAsB;IACtB,+CAA+C;IAC/C,uBAAuB;IACvB,kDAAkD;AACtD;AACA;IACI,kCAAkC;IAClC,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,2CAA2C;IAC3C,6CAA6C;IAC7C,8CAA8C;IAC9C,sBAAsB;IACtB,8CAA8C;IAC9C,8BAA8B;IAC9B,kDAAkD;AACtD;AACA;IACI,kCAAkC;IAClC,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,2CAA2C;IAC3C,8CAA8C;IAC9C,+CAA+C;IAC/C,sBAAsB;IACtB,8CAA8C;IAC9C,8BAA8B;IAC9B,kDAAkD;AACtD;AACA;IACI,iCAAiC;AACrC;AACA;IACI,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;AACzB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;AACzB;AACA;IACI,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,mDAAqC,EAAE,gCAAgC;IACvE,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI;QACI,wBAAwB;QACxB,yBAAyB;QACzB,6BAA6B;QAC7B,2BAA2B;QAC3B,WAAW;QACX,YAAY;QACZ,aAAa;QACb,2BAA2B;QAC3B,oBAAoB;QACpB,qBAAqB;QACrB,MAAM;QACN,cAAc;QACd,oBAAoB;QACpB,iCAAiC;QACjC,2BAA2B;QAC3B,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB;AACJ;;AAEA;IACI,gBAAgB;IAChB,kDAAkD;AACtD;;AAEA;;;;IAII,oBAAoB;IACpB,2BAA2B;IAC3B,2BAA2B;AAC/B;;;AAGA;IACI,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;IAClC,oBAAoB;AACxB;;AAEA;IACI,uDAAuD;IACvD,6CAA6C;AACjD;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,6CAA6C;IAC7C,2BAA2B;IAC3B,qBAAqB;IACrB,oDAAoD;AACxD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;;;IAII,yDAAiD;IAAjD,iDAAiD;IACjD,kCAAkC;AACtC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,+CAA+C;IAC/C,mDAA0C;IAC1C,YAAY;IACZ,sBAAsB;IACtB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,+CAA+C;IAC/C,mDAAyC;IACzC,YAAY;IACZ,sBAAsB;IACtB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kEAAkE;AACtE;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,sCAAsC;IACtC,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iDAAiD;IACjD,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,4CAA4C;IAC5C,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,2DAA2D;AAC/D;;AAEA;IACI,kDAAkD;IAClD,0BAA0B;IAC1B,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mDAAuC;IACvC,cAAc;IACd,aAAa;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;IACI,kDAAkD;IAClD,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,+CAA+C;AACnD;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,WAAW;IACX,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,+BAA+B;IAC/B,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;AACF;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,cAAc;QACd,2BAA2B;IAC/B;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,aAAa;QACb,2BAA2B;QAC3B,oBAAoB;QACpB,qBAAqB;QACrB,MAAM;QACN,cAAc;QACd,oBAAoB;QACpB,iCAAiC;QACjC,uBAAuB;QACvB,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;QAChB,sBAAsB;QACtB,eAAe;IACnB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,eAAe;QACf,sBAAsB;IAC1B;;IAEA;QACI,eAAe;QACf,sBAAsB;QACtB,cAAc;QACd,qBAAqB;QACrB,mBAAmB;IACvB;;IAEA;;QAEI,6CAA6C;IACjD;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mDAA2C,EAAE,gCAAgC;QAC7E,sBAAsB;QACtB,YAAY,EAAE,gCAAgC;QAC9C,aAAa,EAAE,iCAAiC;IACpD;;IAEA;QACI,mDAAmD;QACnD,yCAAyC;QACzC,mDAAmD;QACnD,mDAAmD;QACnD,sDAAsD;IAC1D;;IAEA;;;;QAII,oCAAoC;QACpC,sBAAsB;IAC1B;;IAEA;QACI,oCAAoC;QACpC,sBAAsB;IAC1B;;IAEA;;;;QAII,oCAAoC;IACxC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;;;QAGI,sBAAsB;QACtB,0DAA0D;IAC9D;;IAEA;;;QAGI,sBAAsB;IAC1B;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,oCAAoC;QACpC,WAAW;IACf;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;AAEJ;;AAEA,gBAAgB;;AAEhB;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB","sourcesContent":["* {\r\n    font-family: 'Poppins' !important;\r\n}\r\n\r\n:root {\r\n    --dl-color-gray-500: #595959;\r\n    --dl-color-gray-700: #999999;\r\n    --dl-color-gray-900: #d9d9d9;\r\n    --dl-size-size-large: 144px;\r\n    --dl-size-size-small: 48px;\r\n    --dl-color-danger-300: #a22020;\r\n    --dl-color-danger-500: #bf2626;\r\n    --dl-color-danger-700: #e14747;\r\n    --dl-color-gray-black: #000000;\r\n    --dl-color-gray-white: #ffffff;\r\n    --dl-size-size-medium: 96px;\r\n    --dl-size-size-xlarge: 192px;\r\n    --dl-size-size-xsmall: 16px;\r\n    --dl-space-space-unit: 8px;\r\n    --dl-color-primary-100: #003eb3;\r\n    --dl-color-primary-300: #0074f0;\r\n    --dl-color-primary-500: #14a9ff;\r\n    --dl-color-primary-700: #85dcff;\r\n    --dl-color-success-300: #199033;\r\n    --dl-color-success-500: #32a94c;\r\n    --dl-color-success-700: #4cc366;\r\n    --dl-size-size-xxlarge: 288px;\r\n    --dl-size-size-maxwidth: 1400px;\r\n    --dl-radius-radius-round: 50%;\r\n    --dl-color-custom-accent1: #ffe4df;\r\n    --dl-space-space-halfunit: 8px;\r\n    --dl-space-space-sixunits: 96px;\r\n    --dl-space-space-twounits: 32px;\r\n    --dl-color-custom-primary1: #d53636;\r\n    --dl-color-custom-primary2: #a92323;\r\n    --dl-radius-radius-radius2: 2px;\r\n    --dl-radius-radius-radius4: 4px;\r\n    --dl-radius-radius-radius8: 8px;\r\n    --dl-space-space-fiveunits: 80px;\r\n    --dl-space-space-fourunits: 64px;\r\n    --dl-space-space-threeunits: 48px;\r\n    --dl-color-custom-secondary1: #c9edf3;\r\n    --dl-color-custom-neutral-dark: #27284e;\r\n    --dl-color-custom-neutral-light: #ffffff;\r\n    --dl-space-space-oneandhalfunits: 24px;\r\n    --dl-grid-gap-space: 8px;\r\n\r\n    --dl-color-custom-font: black;\r\n    --dl-color-custom-primary: #1c7ba8;\r\n    --dl-color-custom-primary-darker: #14a9ff;\r\n    --dl-color-custom-secondary: #ffffff;\r\n    --dl-color-custom-secondary-darker: #d9d9d9;\r\n}\r\n.button {\r\n    color: var(--dl-color-gray-black);\r\n    display: inline-block;\r\n    padding: 0.5rem 1rem;\r\n    border-color: var(--dl-color-gray-black);\r\n    border-width: 1px;\r\n    border-radius: 4px;\r\n    background-color: var(--dl-color-gray-white);\r\n}\r\n.input {\r\n    color: var(--dl-color-custom-font) !important;\r\n    cursor: auto;\r\n    padding: 0.5rem 1rem;\r\n    border-color: var(--dl-color-custom-primary);\r\n    border-width: 1px;\r\n    border-radius: 4px;\r\n    background-color: var(--dl-color-custom-secondary);\r\n}\r\n.textarea {\r\n    color: var(--dl-color-custom-font);\r\n    cursor: auto;\r\n    padding: 0.5rem;\r\n    border-color: var(--dl-color-custom-primary);\r\n    border-width: 1px;\r\n    border-radius: 4px;\r\n    background-color: var(--dl-color-custom-secondary);\r\n}\r\n.list {\r\n    width: 100%;\r\n    margin: 1em 0px 1em 0px;\r\n    display: block;\r\n    padding: 0px 0px 0px 1.5rem;\r\n    list-style-type: none;\r\n    list-style-position: outside;\r\n}\r\n.list-item {\r\n    display: list-item;\r\n}\r\n.teleport-show {\r\n    display: flex !important;\r\n    transform: none !important;\r\n}\r\n.buttonFilled {\r\n    color: var(--dl-color-custom-secondary) !important;\r\n    transition: 0.3s;\r\n    font-weight: bold !important;\r\n    padding-top: var(--dl-space-space-halfunit) !important;\r\n    padding-left: var(--dl-space-space-oneandhalfunits) !important;\r\n    border-radius: 8px !important;\r\n    padding-right: var(--dl-space-space-oneandhalfunits) !important;\r\n    padding-bottom: var(--dl-space-space-halfunit) !important;\r\n    background-color: var(--dl-color-custom-primary) !important;\r\n    margin-top: 10px !important;\r\n}\r\n.buttonFilled:hover {\r\n    background-color: var(--dl-color-custom-primary-darker) !important;\r\n}\r\n.buttonFilledSecondary {\r\n    color: var(--dl-color-custom-secondary);\r\n    transition: 0.3s;\r\n    font-weight: bold;\r\n    padding-top: var(--dl-space-space-halfunit);\r\n    padding-left: var(--dl-space-space-oneandhalfunits);\r\n    padding-right: var(--dl-space-space-oneandhalfunits);\r\n    padding-bottom: var(--dl-space-space-halfunit);\r\n    background-color: var(--dl-color-custom-primary);\r\n}\r\n.buttonFilledSecondary:hover {\r\n    background-color: var(--dl-color-custom-primary-darker);\r\n}\r\n.buttonOutline {\r\n    color: var(--dl-color-custom-primary);\r\n    border: 1px solid;\r\n    font-weight: bold;\r\n    padding-top: var(--dl-space-space-halfunit);\r\n    border-color: var(--dl-color-custom-primary);\r\n    padding-left: var(--dl-space-space-oneandhalfunits);\r\n    border-radius: 8px;\r\n    padding-right: var(--dl-space-space-oneandhalfunits);\r\n    padding-bottom: var(--dl-space-space-halfunit);\r\n}\r\n.buttonOutline:hover {\r\n    background-color: var(--dl-color-custom-primary-darker);\r\n}\r\n.buttonFlat {\r\n    color: var(--dl-color-custom-primary);\r\n    font-weight: bold;\r\n    padding-top: var(--dl-space-space-halfunit);\r\n    padding-left: var(--dl-space-space-oneandhalfunits);\r\n    padding-right: var(--dl-space-space-oneandhalfunits);\r\n    padding-bottom: var(--dl-space-space-halfunit);\r\n}\r\n.buttonFlat:hover {\r\n    color: var(--dl-color-custom-primary-darker);\r\n}\r\n.featuresContainer {\r\n    flex: 0 0 auto;\r\n    color: var(--dl-color-custom-font);\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    background-color: var(--dl-color-custom-secondary);\r\n}\r\n\r\n.featuresCard {\r\n    width: 100%;\r\n    display: flex;\r\n    padding: var(--dl-space-space-oneandhalfunits);\r\n    align-items: center;\r\n    flex-direction: row;\r\n    justify-content: flex-start;\r\n    color: #000;\r\n    background-color: #e5e7eb;\r\n    border-radius: 5px;\r\n    position: relative;\r\n}\r\n\r\n.featuresIcon {\r\n    fill: #000;\r\n    width: 3rem;\r\n    height: 3rem;\r\n    flex-shrink: 0;\r\n    margin-right: var(--dl-space-space-oneandhalfunits);\r\n    margin-top: 0;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.freePricingCard {\r\n    gap: var(--dl-space-space-twounits);\r\n    color: var(--dl-color-custom-secondary);\r\n    width: 100%;\r\n    display: flex;\r\n    padding: var(--dl-space-space-twounits);\r\n    max-width: 450px;\r\n    min-height: 450px;\r\n    align-items: flex-start;\r\n    flex-direction: column;\r\n    background-color: var(--dl-color-custom-primary);\r\n}\r\n.basicPricingCard {\r\n    gap: var(--dl-space-space-twounits);\r\n    color: var(--dl-color-custom-secondary);\r\n    width: 100%;\r\n    display: flex;\r\n    padding: var(--dl-space-space-twounits);\r\n    max-width: 450px;\r\n    min-height: 450px;\r\n    align-items: flex-start;\r\n    flex-direction: column;\r\n    background-color: var(--dl-color-custom-primary);\r\n}\r\n.proPricingCard {\r\n    gap: var(--dl-space-space-twounits);\r\n    color: var(--dl-color-custom-secondary);\r\n    width: 100%;\r\n    display: flex;\r\n    padding: var(--dl-space-space-twounits);\r\n    max-width: 450px;\r\n    min-height: 450px;\r\n    align-items: flex-start;\r\n    flex-direction: column;\r\n    background-color: var(--dl-color-custom-primary);\r\n}\r\n.faqContainer {\r\n    flex: 0 0 auto;\r\n    color: var(--dl-color-custom-secondary);\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    background-color: var(--dl-color-custom-primary);\r\n}\r\n.navbarContainer {\r\n    color: var(--dl-color-custom-font);\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    padding-top: var(--dl-space-space-oneandhalfunits);\r\n    padding-left: var(--dl-space-space-threeunits);\r\n    padding-right: var(--dl-space-space-threeunits);\r\n    padding-bottom: var(--dl-space-space-oneandhalfunits);\r\n    justify-content: space-between;\r\n    background-color: var(--dl-color-custom-secondary);\r\n    height: 80px;\r\n    border-bottom: #e5e7eb solid 1px;\r\n}\r\n\r\n@media only screen and (max-width: 820px) {\r\n    .navbarContainer {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n    }\r\n\r\n    .home-desktop-menu {\r\n        display: none !important;\r\n    }\r\n}\r\n\r\n.mobileMenu {\r\n    color: var(--dl-color-custom-font);\r\n    background-color: var(--dl-color-custom-secondary);\r\n}\r\n.heroContainer {\r\n    color: var(--dl-color-custom-font);\r\n    width: 100%;\r\n    display: flex;\r\n    min-height: auto;\r\n    align-items: center;\r\n    padding-top: var(--dl-space-space-sixunits);\r\n    padding-left: var(--dl-space-space-threeunits);\r\n    padding-right: var(--dl-space-space-threeunits);\r\n    flex-direction: column;\r\n    padding-bottom: var(--dl-space-space-sixunits);\r\n    justify-content: center;\r\n    background-color: var(--dl-color-custom-secondary);\r\n}\r\n.pricingContainer {\r\n    gap: var(--dl-space-space-twounits);\r\n    color: var(--dl-color-custom-font);\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    padding-top: var(--dl-space-space-fourunits);\r\n    padding-left: var(--dl-space-space-threeunits);\r\n    padding-right: var(--dl-space-space-threeunits);\r\n    flex-direction: column;\r\n    padding-bottom: var(--dl-space-space-fourunits);\r\n    justify-content: center;\r\n    background-color: var(--dl-color-custom-secondary);\r\n}\r\n.bannerContainer {\r\n    color: var(--dl-color-custom-font);\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    padding-top: var(--dl-space-space-sixunits);\r\n    padding-left: var(--dl-space-space-fiveunits);\r\n    padding-right: var(--dl-space-space-fiveunits);\r\n    flex-direction: column;\r\n    padding-bottom: var(--dl-space-space-sixunits);\r\n    justify-content: space-between;\r\n    background-color: var(--dl-color-custom-secondary);\r\n}\r\n.footerContainer {\r\n    color: var(--dl-color-custom-font);\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    padding-top: var(--dl-space-space-twounits);\r\n    padding-left: var(--dl-space-space-threeunits);\r\n    padding-right: var(--dl-space-space-threeunits);\r\n    flex-direction: column;\r\n    padding-bottom: var(--dl-space-space-twounits);\r\n    justify-content: space-between;\r\n    background-color: var(--dl-color-custom-secondary);\r\n}\r\n.socialIcons {\r\n    fill: var(--dl-color-custom-font);\r\n}\r\n.Heading {\r\n    font-size: 32px;\r\n    font-family: 'Poppins';\r\n    font-weight: 700;\r\n    line-height: 1.15;\r\n    text-transform: none;\r\n    text-decoration: none;\r\n}\r\n.heading3 {\r\n    font-size: 20px;\r\n    text-align: center;\r\n    font-family: 'Poppins';\r\n    font-weight: 600;\r\n    line-height: 150%;\r\n}\r\n.Content {\r\n    font-size: 16px;\r\n    font-family: 'Poppins';\r\n    font-weight: 400;\r\n    line-height: 1.15;\r\n    text-transform: none;\r\n    text-decoration: none;\r\n}\r\n.overline {\r\n    font-size: 12px;\r\n    font-family: 'Poppins';\r\n    font-weight: 700;\r\n    line-height: 150%;\r\n    text-transform: uppercase;\r\n}\r\n.heading2 {\r\n    font-size: 35px;\r\n    font-family: 'Poppins';\r\n    font-weight: 600;\r\n    line-height: 150%;\r\n}\r\n.bodyLarge {\r\n    font-size: 18px;\r\n    font-weight: 400;\r\n    line-height: 150%;\r\n}\r\n.heading1 {\r\n    font-size: 48px;\r\n    text-align: center;\r\n    font-family: 'Poppins';\r\n    font-weight: 700;\r\n    line-height: 150%;\r\n}\r\n.bodySmall {\r\n    font-size: 16px;\r\n    font-weight: 400;\r\n    line-height: 150%;\r\n}\r\n.absence-container {\r\n    margin-top: 150px;\r\n    max-width: 50%;\r\n}\r\n.logo {\r\n    font-size: 2em;\r\n    font-weight: 700;\r\n    line-height: 150%;\r\n    text-transform: uppercase;\r\n    background: url('../public/logo.png'); /* Replace with your logo path */\r\n    background-size: cover;\r\n    width: 250px;\r\n    height: 100px;\r\n    margin-top: -25px;\r\n}\r\n\r\n@media only screen and (min-width: 821px) {\r\n    .home-header .logo {\r\n        margin-top: 0 !important;\r\n        margin-left: 0 !important;\r\n        margin-right: auto !important;\r\n        margin-bottom: 0 !important;\r\n        width: auto;\r\n        height: auto;\r\n        min-height: 0;\r\n        background: none !important;\r\n        display: inline-flex;\r\n        align-items: baseline;\r\n        gap: 0;\r\n        line-height: 1;\r\n        text-transform: none;\r\n        font-family: 'Poppins' !important;\r\n        justify-content: flex-start;\r\n        text-align: left;\r\n        align-self: center;\r\n    }\r\n\r\n    .home-header .logo::before {\r\n        content: 'Agema';\r\n        color: #1f1f1f;\r\n        font-size: 36px;\r\n        font-weight: 500;\r\n        letter-spacing: 0;\r\n    }\r\n\r\n    .home-header .logo::after {\r\n        content: 'HOME';\r\n        color: #2280b3;\r\n        font-size: 36px;\r\n        font-weight: 700;\r\n        letter-spacing: 0;\r\n    }\r\n}\r\n\r\nbody {\r\n    min-height: 100%;\r\n    background-color: var(--dl-color-custom-secondary);\r\n}\r\n\r\nhtml,\r\nbody,\r\n#root,\r\n.home-container {\r\n    border: 0 !important;\r\n    border-radius: 0 !important;\r\n    box-shadow: none !important;\r\n}\r\n\r\n\r\nform {\r\n    background: none;\r\n    color: var(--dl-color-custom-font);\r\n}\r\n\r\n.MuiPaper-root {\r\n    background: transparent !important;\r\n    border: 0 !important;\r\n}\r\n\r\nform fieldset {\r\n    border-color: var(--dl-color-custom-primary) !important;\r\n    color: var(--dl-color-custom-font) !important;\r\n}\r\n\r\nform button span {\r\n    color: var(--dl-color-custom-secondary) !important;\r\n}\r\n\r\nform label {\r\n    color: var(--dl-color-custom-font) !important;\r\n}\r\n\r\n.MuiInputBase-input {\r\n    color: var(--dl-color-custom-font) !important;\r\n    background: none !important;\r\n    opacity: 1 !important;\r\n    -webkit-text-fill-color: rgba(0, 0, 0, 1) !important;\r\n}\r\n\r\n.MuiInputBase-formControl {\r\n    background: none !important;\r\n}\r\n\r\ninput:-webkit-autofill,\r\ninput:-webkit-autofill:hover,\r\ninput:-webkit-autofill:focus,\r\ninput:-webkit-autofill:active {\r\n    transition: background-color 5000s ease-in-out 0s;\r\n    color: var(--dl-color-custom-font);\r\n}\r\n\r\n.padding-body {\r\n    padding: 50px;\r\n}\r\n\r\n.padding-body-2 {\r\n    padding: 20px;\r\n}\r\n\r\n.padding-body-small {\r\n    padding: 20px;\r\n}\r\n\r\n.document-list th {\r\n    color: var(--dl-color-custom-font);\r\n    font-weight: bold;\r\n}\r\n\r\n.document-list td {\r\n    color: var(--dl-color-custom-font);\r\n}\r\n\r\n.not-mobile {\r\n    width: 100%;\r\n}\r\n\r\n.only-mobile {\r\n    display: none !important;\r\n}\r\n\r\n.MuiOutlinedInput-notchedOutline {\r\n    color: var(--dl-color-custom-primary);\r\n}\r\n\r\n.absenceList-button {\r\n    margin-top: -20px !important;\r\n}\r\n\r\n.MuiList-root {\r\n    background-color: #fff;\r\n}\r\n\r\n.MuiMenuItem-root {\r\n    color: #000 !important;\r\n}\r\n\r\nfieldset legend span {\r\n    color: var(--dl-color-custom-primary) !important;\r\n}\r\n\r\n.MuiSvgIcon-root {\r\n    color: #fff !important;\r\n}\r\n\r\ninput[type='date']::-webkit-calendar-picker-indicator {\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n    margin-right: 2px;\r\n    opacity: 1;\r\n    filter: invert(0.8);\r\n}\r\n\r\ninput[type='date']::-webkit-calendar-picker-indicator:hover {\r\n    opacity: 1;\r\n}\r\n\r\n.MuiButton-root {\r\n    padding-top: 10px !important;\r\n}\r\n\r\n.feature-card-text {\r\n    text-align: left;\r\n}\r\n\r\n.home-features-heading {\r\n    text-align: center;\r\n}\r\n\r\n.cancelButton {\r\n    width: 100%;\r\n    display: block;\r\n    text-align: center;\r\n    cursor: pointer;\r\n}\r\n\r\n.cancelButton:hover {\r\n    color: var(--dl-color-custom-primary1) !important;\r\n}\r\n\r\n.validation-error {\r\n    color: var(--dl-color-custom-primary2);\r\n}\r\n\r\n.validation-error-green {\r\n    color: var(--dl-color-success-300);\r\n}\r\n\r\n.width100 {\r\n    width: 100%;\r\n}\r\n\r\n.loader {\r\n    animation: loading-spinner 0.7s linear infinite;\r\n    background: url('images/loader_white.svg');\r\n    height: 10px;\r\n    width: 10px !important;\r\n    margin: 0 auto;\r\n    display: flex;\r\n}\r\n\r\n.loader svg path {\r\n    fill: #000;\r\n}\r\n\r\n.loader-black {\r\n    animation: loading-spinner 0.7s linear infinite;\r\n    background: url('images/loader_blue.svg');\r\n    height: 30px;\r\n    width: 30px !important;\r\n    margin: 0 auto;\r\n    display: flex;\r\n}\r\n\r\n.other .loader {\r\n    margin-top: 50px;\r\n}\r\n\r\ninput:-webkit-autofill {\r\n    -webkit-text-fill-color: var(--dl-color-custom-primary) !important;\r\n}\r\n\r\n.validation-message {\r\n    line-height: 20px;\r\n    margin: 12px 0;\r\n    color: var(--dl-color-custom-primary1);\r\n    margin-top: 0px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.red-dot {\r\n    width: 10px;\r\n    height: 10px;\r\n    background-color: var(--dl-color-custom-primary1);\r\n    border-radius: 50%;\r\n    position: absolute;\r\n    right: 40px;\r\n    margin-top: 10px;\r\n}\r\n\r\n.green-dot {\r\n    width: 10px;\r\n    height: 10px;\r\n    border-radius: 50%;\r\n    position: absolute;\r\n    right: 40px;\r\n    color: #000;\r\n}\r\n\r\n.green-dot-web {\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 50%;\r\n  right: 40px;\r\n  color:#000;\r\n}\r\n\r\n.green-dot-web {\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 50%;\r\n  right: 40px;\r\n  color:#000;\r\n}\r\n\r\n.holiday-info {\r\n    font-size: 13px;\r\n    margin-top: 5px;\r\n    display: block;\r\n}\r\n\r\n.mt-5 {\r\n    margin-top: 5px;\r\n}\r\n\r\n.white-progress {\r\n    height: 10px;\r\n    border-radius: 5px;\r\n    background-color: rgba(0, 0, 0, 0.1);\r\n    overflow: hidden;\r\n}\r\n\r\n.white-progress .MuiLinearProgress-bar {\r\n    background-color: currentColor !important;\r\n}\r\n\r\n.chat-gpt {\r\n    margin-top: 10px;\r\n}\r\n\r\n.mt-10 {\r\n    margin-top: 15px;\r\n}\r\n\r\n.forgot-password {\r\n    color: var(--dl-color-custom-primary);\r\n}\r\n\r\n.chat-gpt h5 {\r\n    background: var(--dl-color-custom-secondary);\r\n    border-radius: 5px;\r\n    padding: 5px;\r\n    display: block;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.chat-gpt p {\r\n    margin: 5px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.MuiDialog-paper {\r\n    background-color: var(--dl-color-custom-secondary) !important;\r\n}\r\n\r\n.MuiDialogActions-root .cancelButton {\r\n    margin-top: 7px;\r\n    color: #000;\r\n    cursor: pointer;\r\n}\r\n\r\n.MuiDialogActions-root button {\r\n    background-color: var(--dl-color-custom-primary) !important;\r\n}\r\n\r\n.scroll-top-button {\r\n    color: var(--dl-color-custom-secondary) !important;\r\n    position: fixed !important;\r\n    bottom: 20px;\r\n    right: 20px;\r\n    height: 52px;\r\n    width: 52px;\r\n}\r\n\r\n.scroll-top-button svg {\r\n    height: 50px;\r\n    width: 50px;\r\n    background: url('images/button_up.svg');\r\n    margin: 0 auto;\r\n    display: flex;\r\n}\r\n\r\n.scroll-top-button svg path{\r\n  display: none;\r\n} \r\n\r\n.button-circle {\r\n    color: var(--dl-color-custom-secondary) !important;\r\n    height: 52px;\r\n    width: 52px;\r\n    float: right;\r\n}\r\n\r\n.button-circle svg {\r\n    height: 52px;\r\n    width: 52px;\r\n    fill: var(--dl-color-custom-primary) !important;\r\n}\r\n\r\n.pointer {\r\n    cursor: pointer;\r\n    font-weight: 300;\r\n}\r\n\r\n.absence-item-wrapper {\r\n    position: relative;\r\n    overflow: hidden;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.delete-button-area {\r\n    position: absolute;\r\n    right: 0;\r\n    height: 97%;\r\n    width: 70px;\r\n    background-color: red;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 5px;\r\n}\r\n\r\n.delete-btn {\r\n    background: none;\r\n    border: none;\r\n    color: white;\r\n    font-size: 24px;\r\n    cursor: pointer;\r\n}\r\n\r\n.absence-item-content {\r\n    flex: 1;\r\n    transition: transform 0.3s ease;\r\n    will-change: transform;\r\n}\r\n\r\n.absence-item-content.slid {\r\n    transform: translateX(-70px);\r\n}\r\n\r\n.MuiSvgIcon-root{\r\n  color:#000 !important;\r\n}\r\n\r\n.absenceRejectLink{\r\n  color:#fe0000\r\n}\r\n\r\n@keyframes loading-spinner {\r\n    from {\r\n        transform: rotate(0deg);\r\n    }\r\n    to {\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 820px) {\r\n    .logo {\r\n        margin: 0 auto;\r\n        background-position-x: 20px;\r\n    }\r\n\r\n    .home-header .logo {\r\n        margin: 0 auto !important;\r\n        width: auto;\r\n        height: auto;\r\n        min-height: 0;\r\n        background: none !important;\r\n        display: inline-flex;\r\n        align-items: baseline;\r\n        gap: 0;\r\n        line-height: 1;\r\n        text-transform: none;\r\n        font-family: 'Poppins' !important;\r\n        justify-content: center;\r\n        text-align: left;\r\n        align-self: center;\r\n    }\r\n\r\n    .home-header .logo::before {\r\n        content: 'Agema';\r\n        color: #1f1f1f;\r\n        font-size: 36px;\r\n        font-weight: 500;\r\n        letter-spacing: 0;\r\n    }\r\n\r\n    .home-header .logo::after {\r\n        content: 'HOME';\r\n        color: #2280b3;\r\n        font-size: 36px;\r\n        font-weight: 700;\r\n        letter-spacing: 0;\r\n    }\r\n\r\n    .buttonFilled {\r\n        margin-top: 20px !important;\r\n        margin-bottom: 20px !important;\r\n    }\r\n\r\n    .center .buttonFilled {\r\n        margin: 0 auto;\r\n        margin-top: -20px;\r\n    }\r\n\r\n    .not-mobile {\r\n        display: none !important;\r\n    }\r\n\r\n    .only-mobile {\r\n        display: block !important;\r\n    }\r\n\r\n    .only-mobile .heading3 {\r\n        text-align: left;\r\n        font-family: 'Poppins';\r\n        font-size: 18px;\r\n    }\r\n\r\n    .home-burger-menu {\r\n        display: none !important;\r\n    }\r\n\r\n    .only-mobile .bodySmall {\r\n        font-size: 14px;\r\n        font-family: 'Poppins';\r\n    }\r\n\r\n    .only-mobile .bodySmall-2 {\r\n        font-size: 14px;\r\n        font-family: 'Poppins';\r\n        max-width: 80%;\r\n        word-break: break-all;\r\n        white-space: normal;\r\n    }\r\n\r\n    .MuiSelect-icon,\r\n    .MuiSelect-iconOutlined {\r\n        color: var(--dl-color-custom-font) !important;\r\n    }\r\n\r\n    .absence-container {\r\n        margin-top: 80px;\r\n        max-width: 100%;\r\n    }\r\n\r\n    .home-text51 {\r\n        text-align: center;\r\n    }\r\n\r\n    .home-btn-group {\r\n        width: 100%;\r\n        text-align: center;\r\n    }\r\n\r\n    .clr {\r\n        clear: both;\r\n    }\r\n\r\n    body {\r\n        line-height: 18px !important;\r\n    }\r\n\r\n    .absence-card {\r\n        padding-top: 15px;\r\n        padding-bottom: 20px;\r\n    }\r\n\r\n    .absence-card .bodySmall {\r\n        line-height: 10px;\r\n    }\r\n\r\n    .faqContainer .bodySmall {\r\n        text-align: center !important;\r\n    }\r\n\r\n    .margin-bottom-0 {\r\n        margin-bottom: 0 !important;\r\n    }\r\n\r\n    .navbarContainer {\r\n        height: 100px;\r\n    }\r\n\r\n    .logo {\r\n        margin-top: -20px;\r\n    }\r\n\r\n    .absenceLink {\r\n        color: #666;\r\n    }\r\n}\r\n\r\n@media (prefers-color-scheme: dark) {\n    .home-navbar-interactive {\n        background-color: #121212;\n    }\n\n    .home-header .logo::before {\n        color: #ffffff;\n    }\n\n    .logo {\n        background: url('../public/logo_white.png'); /* Replace with your logo path */\n        background-size: cover;\r\n        width: 250px; /* Set a width for the element */\r\n        height: 100px; /* Set a height for the element */\r\n    }\r\n\r\n    :root {\r\n        --dl-color-custom-neutral-light: #121212 !important;\r\n        --dl-color-gray-white: #121212 !important;\r\n        --dl-color-custom-neutral-light: #121212 !important;\r\n        --dl-color-custom-neutral-light: #121212 !important;\r\n        --dl-color-custom-secondary-darker: #121212 !important;\r\n    }\r\n\r\n    html,\r\n    body,\r\n    #root,\r\n    .home-container {\r\n        background-color: #121212 !important;\r\n        color: #fff !important;\r\n    }\r\n\r\n    form {\r\n        background-color: #121212 !important;\r\n        color: #fff !important;\r\n    }\r\n\r\n    .MuiFormControl-root,\r\n    .MuiInputBase-root,\r\n    .MuiOutlinedInput-root,\r\n    .MuiInputBase-formControl {\r\n        background-color: #1a2733 !important;\r\n    }\r\n\r\n    .MuiOutlinedInput-notchedOutline {\r\n        border-color: #2a9cda !important;\r\n    }\r\n\r\n    .MuiInputBase-input,\r\n    .MuiSelect-select,\r\n    textarea.MuiInputBase-input {\r\n        color: #fff !important;\r\n        -webkit-text-fill-color: rgba(255, 255, 255, 1) !important;\r\n    }\r\n\r\n    form label,\r\n    .MuiFormLabel-root,\r\n    .MuiInputLabel-root {\r\n        color: #fff !important;\r\n    }\r\n\r\n    .heroContainer {\r\n        background-color: #121212 !important;\r\n    }\r\n\r\n    .featuresContainer {\r\n        background-color: #121212 !important;\r\n    }\r\n\r\n    .bannerContainer {\r\n        background-color: #121212 !important;\r\n        color: #fff;\r\n    }\r\n\r\n    .footerContainer {\r\n        background-color: #121212 !important;\r\n    }\r\n\r\n    .heroContainer {\r\n        color: #fff;\r\n    }\r\n\r\n    .home-container2 {\r\n        color: #fff;\r\n    }\r\n\r\n    .document-list th {\r\n        color: #fff;\r\n    }\r\n\r\n    .document-list td {\r\n        color: #fff;\r\n    }\r\n\r\n}\r\n\r\n/* AbsenceCard */\r\n\r\n.absence-card-box {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 20px;\r\n    padding: 10px 16px;\r\n    border-radius: 8px;\r\n    background-color: #e5e7eb;\r\n    color: #000;\r\n    box-sizing: border-box;\r\n    cursor: pointer;\r\n}\r\n\r\n.absence-card-left {\r\n    flex: 0 0 48px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.absence-card-center {\r\n    flex: 1 1 auto;\r\n    min-width: 0;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n}\r\n\r\n.absence-card-right {\r\n    flex: 0 0 40px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.absence-type-icon {\r\n    width: 3rem;\r\n    height: 3rem;\r\n    display: block;\r\n}\r\n\r\n.status-icon {\r\n    font-size: 30px !important;\r\n    color: #000 !important;\r\n    opacity: 0.7;\r\n    transform: scale(0.9);\r\n}\r\n\r\n.absence-card-center .feature-card-text {\r\n    margin: 0 0 4px 0;\r\n    text-align: left;\r\n}\r\n\r\n.absence-card-center .bodySmall {\r\n    display: block;\r\n    line-height: 1.4;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
